import React from 'react'

const YearlyChecklistSectionD = () => {
  return (
      <section className="mt-5">
          <div className="heading-4">
              Section D: Annual reports
          </div>

          <p className="heading-5">You are required to file the 2020 Annual report by March 31, 2021</p>
          <p className="heading-5 mt-5">You can refer to Compliance Reports -- Annual Reports for preparing for this filing</p>
      </section>

  )
}

export default YearlyChecklistSectionD